// How many tag chips stay inline before the rest collapses into the
// "+N more" popover, keeping the filter row on a single line.
export const MAX_VISIBLE_TAGS = 6

export const SEARCH_DEBOUNCE_MS = 250

// Mirrors the prototype's 30s revalidate window while articles are authored.
export const QUERY_STALE_TIME_MS = 30000
export const QUERY_RETRY = 1

// Thumbnails render at 80x56; fetch at 2x for retina screens.
export const THUMBNAIL_WIDTH = 80
export const THUMBNAIL_HEIGHT = 56
export const THUMBNAIL_FETCH_SCALE = 2

export const ARTICLE_IMAGE_MAX_WIDTH = 1200

export const ROW_TITLE_LINE_HEIGHT = 1.35

export const HUB_ICON_SIZE = 28
export const HUB_THEME_ICON_SIZE = 52
export const TAB_ICON_SIZE = 18
export const BADGE_ICON_SIZE = 12
export const ROW_ARROW_ICON_SIZE = 16
export const SEARCH_ICON_SIZE = 16
export const BACK_ICON_SIZE = 16

export const TAG_POPOVER_WIDTH = 320
